<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Load Movement', apiMethod: 'LoadMovements', form: () => import('../forms/LoadMovementForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Pollination', apiMethod: 'Pollinations', parentForeignKey: 'loadMovementId', form: () => import('../forms/PollinationForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Pollinations', value: 'loadMovementId', isCard: true, table: () => import('../tables/PollinationsTable') },
                ],
                mainForm: () => import('../forms/LoadMovementForm'),
                claimName: 'LoadMovements',
                apiMethod: 'LoadMovements',
            }
        }
    };
</script>
